var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTickFilled = function SvgTickFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M.674 2.778C0 3.787 0 5.19 0 8c0 2.809 0 4.213.674 5.222.292.437.667.812 1.104 1.104C2.787 15 4.19 15 7 15h2c2.809 0 4.213 0 5.222-.674a4.003 4.003 0 0 0 1.104-1.104C16 12.213 16 10.81 16 8c0-2.809 0-4.213-.674-5.222a4.002 4.002 0 0 0-1.104-1.104C13.213 1 11.81 1 9 1H7c-2.809 0-4.213 0-5.222.674A4 4 0 0 0 .674 2.778Zm10.93 3.246a.8.8 0 1 0-1.208-1.048L7.125 8.75l-1-1.25a.8.8 0 0 0-1.25 1l1.6 2a.8.8 0 0 0 1.23.024l3.9-4.5Z",
    clipRule: "evenodd"
  })));
};
export default SvgTickFilled;